import React from 'react';
import Avatar from '../types/avatar';
import AvatarPastille from './AvatarPastille';

export interface AvatarListProps {
  avatars: Avatar[];
}

const AvatarList: React.FC<AvatarListProps> = ({ avatars }) => (
  <>
    {avatars.map(avatar => (
      <div data-testid={`avatar-for-${avatar._id}`} key={avatar._id}>
        <AvatarPastille
          avatar={{
            _id: avatar._id,
            fname: avatar.fname,
            lname: avatar.lname,
          }}
          tooltip
        />
      </div>
    ))}
  </>
);

export default AvatarList;
